import { PortalTypeIdEnum } from '../enum/shared/portal-type-id.enum';
import { Deserializable } from '../protocols/deserializable';
import { MemberSubmissionTypeEnum } from '../users/enum/member-submission-type-enum';
import { EmployerSubmissionTypeEnum } from '../users/enum/employer-submission-type.enum';
import { MemberSubmissionStatus } from './member-submission-status';
import { SubmissionSubStatus } from './submission-sub-status';

export class RecentMemberSubmissionResponse implements Deserializable {
  public memberId!: number;
  public totalSubmissionCount!: number;
  public activeSubmissions?: RecentMemberSubmission[];
  public previousSubmissions?: RecentMemberSubmission[];

  onDeserialize(): void {
    if (!!this.activeSubmissions) {
      this.activeSubmissions = window?.injector?.Deserialize?.arrayOf(RecentMemberSubmission, this.activeSubmissions);
    }
    if (!!this.previousSubmissions) {
      this.previousSubmissions = window?.injector?.Deserialize?.arrayOf(
        RecentMemberSubmission,
        this.previousSubmissions
      );
    }
  }
}

export class RecentMemberSubmission implements Deserializable {
  public portalTypeId!: PortalTypeIdEnum;
  public submissionId!: number;
  public idPrefix!: string;
  public idSuffix!: string;
  public submissionTypeId!: MemberSubmissionTypeEnum | EmployerSubmissionTypeEnum;
  public submissionTypeName!: string;
  public statusId!: number;
  public status!: MemberSubmissionStatus;
  public subStatusId!: number | null;
  public subStatus!: SubmissionSubStatus;
  public completedDate!: string | null;
  public submittedDate!: string | null;

  // Not From API
  public formattedSubmissionId!: string;

  onDeserialize(): void {
    this.formattedSubmissionId = this.buildSubmissionId();
    if (!!this.status) {
      this.status = window?.injector?.Deserialize?.instanceOf(MemberSubmissionStatus, this.status);
    }
    if (!!this.subStatus) {
      this.subStatus = window?.injector?.Deserialize?.instanceOf(SubmissionSubStatus, this.subStatus);
    }
  }

  private buildSubmissionId(): string {
    const paddedId = this.submissionId.toString().padStart(8, '0');
    return `${this.idPrefix}-${paddedId}-${this.idSuffix}`;
  }
}
